import { Tooltip } from "@zapier/design-system-beta";
import { ReactNode, useEffect, useState } from "react";

type Props = {
  key?: string;
  content: string;
  ariaLabel?: string;
  placement?: "top" | "bottom" | "left" | "right";
  offset?: "small" | "medium" | "large";
  className?: string;
  onChange: (value: string) => void;
  children: ReactNode;
  name: string;
  value: string;
  isChecked?: boolean;
};

export function ControlledTooltipRadioButton({
  key,
  content,
  ariaLabel,
  placement = "top",
  offset = "large",
  className,
  onChange,
  children,
  name,
  value,
  isChecked,
}: Props) {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [tooltipTimeoutId, setTooltipTimeoutId] =
    useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (tooltipTimeoutId) {
        clearTimeout(tooltipTimeoutId);
      }
    };
  }, [tooltipTimeoutId]);

  const handleFocus = () => {
    setIsTooltipVisible(true);
    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }
    setTooltipTimeoutId(setTimeout(() => setIsTooltipVisible(false), 1500)); // 2000ms = 2 seconds
  };

  const handleBlur = () => {
    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }
    setIsTooltipVisible(false);
  };
  const handleMouseEnter = () => {
    setIsTooltipVisible(true);
    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }
    setTooltipTimeoutId(setTimeout(() => setIsTooltipVisible(false), 1500)); // 1.5 seconds
  };

  const handleMouseLeave = () => {
    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }
    setIsTooltipVisible(false);
  };

  return (
    <Tooltip
      key={key}
      content={content}
      isOpen={isTooltipVisible}
      placement={placement}
      offset={offset}
    >
      <Tooltip.FocusableTrigger>
        <label className={className}>
          <input
            type="radio"
            name={name}
            value={value}
            checked={isChecked}
            aria-label={ariaLabel}
            className={className}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onChange={(event) => onChange(event.target.value)}
          />
          {children}
        </label>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}
